import { APIServiceError } from 'frontcore/data/api-service/service-error/errors/service-error'


export class APIServiceException<SD = unknown> extends APIServiceError<SD> {}

export class UnknownFileTypeError extends APIServiceException {
  get serviceDetail (): string {
    const detail = this.response?.data.service_detail
    if (typeof detail === 'string') {
      return detail
    }
    return this.message
  }
}
